import { useCallback } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { getProjectPlanPath } from '../../../../../lib/functions/projectPlan'
import store from '../../../../../store'
import { addGlobalMessage, MessageLevel } from '../../../../../store/messages'
import { intl } from '../../../../../i18n'
import '../../../../../styles/agGrid.scss'

export const ProcessRowNumberCellRenderer = ({
  data,
  value,
}: ICellRendererParams<ProgressReportTableContent>) => {
  const processUuid = data?.uuid

  const handleClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation()
      if (!processUuid) return

      const projectCode = store.getState().project.current?.code
      if (!projectCode) return

      try {
        await getProjectPlanPath(processUuid)
        const url = `${window.location.origin}/projectPlan/${projectCode}?treeRootUuid=${processUuid}`
        window.open(url, '_blank')
      } catch {
        store.dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({
              id: 'versionReport.progressReport.process.notFound',
            }),
          })
        )
      }
    },
    [processUuid]
  )

  return (
    <div className="sevend-ag-cell-sequence-no">
      {processUuid ? (
        <a className="sevend-ag-cell-sequence-no__link" onClick={handleClick}>
          {value}
        </a>
      ) : (
        <p className="sevend-ag-cell-sequence-no__label">{value}</p>
      )}
    </div>
  )
}
